<template>
  <table class="header_table fixed_headers">
    <caption v-if="captionContents">{{ captionContents }}</caption>
    <calendar-cols />
    <thead>
    <tr>
      <th class="years_header"><span>{{ topLeftCellContents }}</span></th>
      <th v-for="month in monthNames" :key="month">{{ month }}</th>
    </tr>
    </thead>
  </table>
</template>
<script setup>
import CalendarCols from "./CalendarCols.vue";
import { monthNames } from "../../lib/helpers";

const props = defineProps({
  topLeftCellContents: {
    type: String,
    default: "Years"
  },
  captionContents: {
    type: String
  }
});

</script>

<style lang="scss" scoped>
@use "./styles/variables.scss" as v;

.header_table{
  width: v.$page_width;
}
</style>


